// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__iVvMS","video":"Video_video__7yBp8","poster":"Video_poster__Cwe1r","posterButton":"Video_posterButton__3sy4w","is_hidden":"Video_is_hidden__n4IXh"};